CostesDetallesCtrl.$inject = ['$log', 'CostesActionsService', '$http'];
export default function CostesDetallesCtrl($log, CostesActionsService, $http) {

    var costDet = this;

    costDet.cargandoCostes = true;
    costDet.tareaId = costDet.tareaId;
    costDet.puedeEditar = Sigo.user.puedeEditarCostes;

    costDet.costes = [];
    costDet.tarea = null;

    costDet.costesForView = chunkArray(costDet.costes, 2);

    costDet.editarValores = function (id) {
        var valores = null;
        for (var i = 0; i < costDet.costes.length; i++) {
            if (costDet.costes[i].id == id) {
                valores = costDet.costes[i];
                break;
            }
        }

        if (valores != null) {
            CostesActionsService.dialogEditCostes(angular.copy(valores), costDet.tareaId).then(function (res) {
                    costDet.cargarCostes(costDet.tareaId);
                }
            );
        }
    };

    costDet.costeDelGrupo = function (values) {
        var total = 0;
        for (var i = 0; i < values.length; i++) total += values[i].price * values[i].units;
        return total;
    };

    costDet.costeTotal = function () {
        var total = 0;
        for (var i = 0; i < costDet.costes.length; i++)
            total += costDet.costeDelGrupo(costDet.costes[i].values);
        return total;
    };

    costDet.cargarCostes = function (tareaId) {
        costDet.cargandoCostes = true;

        var url = Sigo.var.path + '/api/v1/tareas/' + tareaId + '/costes';

        var promise = $http.get(url);
        promise.then(function (data) {
            costDet.cargandoCostes = false;
            costDet.costes = data.data;
            costDet.costesForView = chunkArray(costDet.costes, 2);
        }, function (err) {
            Sigo.UI.Messages.open([err.data.message], 0);
        });

        return promise;
    };

    costDet.actualizar = function () {
        $log.debug('Cargando costes para la tarea ' + costDet.tareaId);
        costDet.cargarCostes(costDet.tareaId);
    };

    var cargarTarea = function (tareaId) {
        var url = Sigo.var.path + '/api/v1/tareas/' + tareaId;

        $http.get(url).then(function (data) {
            costDet.tarea = data.data;
        });
    };

    costDet.cargarCostes(costDet.tareaId);
    cargarTarea(costDet.tareaId);
}